import { useEffect } from "react";
import { Location } from "react-router-dom";

const useBackToLink = (backToText: string, location: Location) => {
  // for some reason, useLocation must be called in LegacyApp
  // before calling useBackToLink as a hook
  // this did not seem to be necessary for other routes like Holds
  // after we refactor results and details to routed components
  // we may be able to go back to calling useLocation inside
  // useBackToLink...
  // const location = useLocation();

  useEffect(() => {
    if (!location || !location.pathname) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("Location is undefined or empty!");
      }
      return;
    }

    if (!location.pathname.startsWith("/section=resource")) {
      if (process.env.NODE_ENV !== "production") {
        console.log(`Setting backToLink for ${backToText}`, location);
      }
      sessionStorage.setItem("backToLink", JSON.stringify(location));
      sessionStorage.setItem("backToLinkText", backToText);
    }
  }, [location, backToText]);
};

export default useBackToLink;
